import {
  Component,
  OnDestroy,
  ElementRef,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ProfileUpdateRequestImpl } from "shared/cubiq-model-multi-asset";
import { BfxUserSettingsService, BfxUserSettingsComponentState } from "./bfx-user-settings.service";
import {
  BfxUserSettingsPageComponent,
  BfxUserSettingsValidityState,
} from "./bfx-user-settings-page.component";
import { IBfxUserSettingsPageSubComponent } from "app/bfx-user-settings/bfx-user-settings-page.component";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  SystemConfigPromiseService,
  ProfilePromiseActionService,
  UserPromiseLookupService,
} from "shared/cubiq-services";

@Component({
  selector: ".bfx-bmark-summary-settings",
  templateUrl: "./html/bfx-bmark-summary-settings.html",
  standalone: false,
})
export class BfxBmarkSummarySettingsComponent
  extends BfxUserSettingsPageComponent
  implements OnDestroy
{
  public tableHeight: number = 240;
  public activeSubComponent: number = 2;
  public panelHeight: number = 0;
  private activeTab: number = 0;
  public dataChanged: boolean = false;

  @ViewChildren("subComponent") subComponents: QueryList<
    IBfxUserSettingsPageSubComponent<BfxBmarkSummarySettingsComponent>
  >;

  constructor(
    public userSettingsService: BfxUserSettingsService,
    public systemConfigService: SystemConfigPromiseService,
    public profileService: ProfilePromiseActionService,
    public userService: UserPromiseLookupService,
    public element: ElementRef,
    public translationService: TranslateService,
  ) {
    super();
  }

  public onTabActivated(event: any): void {
    this.activeTab = event.index;
  }

  public initialize(): void {
    this.subComponents.forEach((subComponent) => {
      setImmediate(() => {
        subComponent.initialize();
      });
    });
  }

  ngOnDestroy() {}

  public validate(): Promise<BfxUserSettingsValidityState> {
    let promises: Promise<BfxUserSettingsValidityState>[] = [];

    this.subComponents.forEach((subComponent) => {
      let promise = subComponent.validate();

      promises.push(promise);
    });

    return new Promise<BfxUserSettingsValidityState>((res, reject) => {
      Promise.all(promises).then(
        (values) => {
          let subComponentHasInvalid: boolean = values.some((value) => {
            return value === BfxUserSettingsValidityState.INVALID;
          });
          let subComponentHasActiveUnsaveble: boolean = values.some((value) => {
            return value === BfxUserSettingsValidityState.ACTIVE_UNSAVEABLE;
          });
          let state;

          if (subComponentHasInvalid) {
            state = BfxUserSettingsValidityState.INVALID;
          } else if (subComponentHasActiveUnsaveble) {
            state = BfxUserSettingsValidityState.ACTIVE_UNSAVEABLE;
          } else {
            let subComponentValid: boolean = values.every((value) => {
              return value === BfxUserSettingsValidityState.VALID;
            });
            state = subComponentValid
              ? BfxUserSettingsValidityState.VALID
              : BfxUserSettingsValidityState.INVALID;
          }
          //logger.out.info(`${this.constructor.name}.validate() valid:BfxUserSettingsValidityState.${BfxUserSettingsValidityState[state]}`);
          res(state);
        },
        (err) => {
          reject(err);
        },
      );
    });
  }

  public reset(): Promise<void> {
    let promises: Promise<void>[] = [];

    this.subComponents.forEach((subComponent) => {
      let promise = subComponent.reset();

      promises.push(promise);
    });

    return new Promise<void>((res, reject) => {
      Promise.all(promises).then(
        (values) => {
          // run any reset logic for this.reset now
          // as subComponents did not reject reset

          res();
        },
        () => {
          reject();
        },
      );
    });
  }

  public save(request: ProfileUpdateRequestImpl): void {
    // if (this.dataChanged) {
    this.subComponents.forEach((subComponent) => {
      subComponent.save(request);
    });
    // }
  }

  public postReset(): void {
    this.dataChanged = false;

    this.subComponents.forEach((subComponent) => {
      subComponent.postReset();
    });
  }

  public postSave(request: ProfileUpdateRequestImpl): void {
    let activeUser = this.parentComponent.activeUser;
    // save sub contorl

    this.dataChanged = false;

    this.subComponents.forEach((subComponent) => {
      subComponent.postSave(request);
    });
  }

  public onComponentStateChanged(componentState: BfxUserSettingsComponentState): void {
    this.panelHeight = componentState.componentBounds.height - 120;

    this.subComponents.forEach((subComponent) => {
      subComponent.onComponentStateChanged(componentState);
    });
  }
}
